import React from 'react';
import { Trophy, Layers, ThumbsUp, Users } from 'lucide-react';
import { values } from '../mockData';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '../components/ui/accordion';

const About = () => {
  return (
    <div>
      {/* Page Header */}
      <div className="bg-gray-800 py-16">
        <div className="container mx-auto px-4">
          <h1 className="text-4xl md:text-5xl font-bold text-white text-center">About Us</h1>
        </div>
      </div>

      {/* About Content */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 mb-16">
            <div>
              <img
                src="https://sp-ao.shortpixel.ai/client/to_auto,q_lossy,ret_img,w_240,h_126/https://letsfab.in/wp-content/uploads/2018/04/Pressure-Vessels-Basics-e1587823768823.png"
                alt="Construction Team"
                className="rounded-lg shadow-2xl w-full h-96 object-cover"
              />
            </div>
            <div>
              <span className="text-yellow-500 font-semibold text-sm uppercase tracking-wider">About Aranvic</span>
              <h2 className="text-4xl font-bold text-gray-800 mt-2 mb-4">We deliver landmark projects</h2>
              <p className="text-gray-600 leading-relaxed mb-6">
               Aranvic Industrial Systems is an ISO 9001:2015 certified engineering and manufacturing company 
               delivering landmark projects across aerospace, defence, industrial, automotive, communication,
               and domestic sectors. With a strong technical team and deep expertise in product design, industrial
               instrumentation, fabrication, machining, and battery technology, we consistently achieve First-Time-Right
               execution and on-time delivery for complex, high-value projects.</p>
              <p className="text-gray-600 leading-relaxed mb-6">
               Our capabilities span advanced engineering design, special purpose machinery development, precision manufacturing,
               PCB and embedded system design, as well as patented battery refurbishment technologies. As an approved vendor for
               GTRE-DRDO, BEL, ISRO, BHEL, BEML, and other major organizations, Aranvic continues to drive innovation and deliver 
               reliable, high-performance solutions tailored to critical industry needs.
              </p>
              <div className="grid grid-cols-2 gap-6">
                <div className="flex items-start gap-3">
                  <Trophy className="text-yellow-500 flex-shrink-0" size={40} />
                  <div>
                    <h3 className="font-bold text-gray-800 mb-1">We've Reputation for Excellence</h3>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <Layers className="text-yellow-500 flex-shrink-0" size={40} />
                  <div>
                    <h3 className="font-bold text-gray-800 mb-1">We Build Partnerships</h3>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <ThumbsUp className="text-yellow-500 flex-shrink-0" size={40} />
                  <div>
                    <h3 className="font-bold text-gray-800 mb-1">Guided by Commitment</h3>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <Users className="text-yellow-500 flex-shrink-0" size={40} />
                  <div>
                    <h3 className="font-bold text-gray-800 mb-1">A Team of Professionals</h3>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Our Values */}
          <div className="mt-16">
            <div className="text-center mb-12">
              <h2 className="text-4xl font-bold text-gray-800">Our Core Values</h2>
              <p className="text-gray-600 mt-4 max-w-2xl mx-auto">
                We deliver reliable, precision-engineered solutions with strict adherence to ISO standards and on-time delivery.
              </p>
            </div>

            <div className="max-w-3xl mx-auto">
              <Accordion type="single" collapsible className="space-y-3">
                {values.map((value, index) => (
                  <AccordionItem key={value.id} value={`item-${index}`} className="border border-gray-200 bg-white">
                    <AccordionTrigger className="px-6 py-4 hover:no-underline hover:bg-yellow-50 transition-colors">
                      <span className="font-bold text-gray-800 uppercase">{value.title}</span>
                    </AccordionTrigger>
                    <AccordionContent className="px-6 pb-4">
                      <p className="text-gray-600">{value.description}</p>
                    </AccordionContent>
                  </AccordionItem>
                ))}
              </Accordion>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;